import RoutingActions from '../../actions/RoutingActions';
// import PosActions from '../../../actions/PosActions';
import PopupActions from '../../actions/PopupActions';
// import NotificationActions from '../../../actions/NotificationActions';
// import PosCartActions from '../../../actions/PosCartActions';
// import GuestActions from '../../../actions/GuestActions';

// import UserStore from '../../../stores/UserStore';
// import ConfigStore from '../../../stores/ConfigStore';
// import PosCartStore from '../../../stores/PosCartStore';
// import PosStore from '../../../stores/PosStore';

// import { endPoints as EndPoints } from '../../../constants/PosConstants';

class DisablePos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            apply   : false,
            loyalty : false,
        };

        // this.onChange = this.onChange.bind(this);
    }

    render() {
        var guest                = this.props.guest;

        return (
            <div
                className='popup__content loyalty'
                style={{'textAlign':'center'}}>

                <div className='popup-header'>
                    POS SALE DISABLED
                </div>

                <div style={{'marginTop':40}}>
                    {this.props.data}
                </div>

                <div
                    className='btn-green'
                    style={{'marginTop':40}}
                    onClick={() => {
                        RoutingActions.updateRoute('guest-list');
                        PopupActions.close();
                    }}>

                    OK - Take me back to the guest list
                </div>

            </div>
        );
    }
}

export default DisablePos;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/DisablePos.react.jsx